import React, { useEffect, useState, createContext, useContext } from 'react';
type Language = 'en' | 'es';
interface Translations {
  [key: string]: {
    en: string;
    es: string;
  };
}
export const translations: Translations = {
  // Header
  role: {
    en: 'Luxury Client Advisor',
    es: 'Asesora de Clientes de Lujo'
  },
  collab: {
    en: 'In collaboration with Dahlgren Duck',
    es: 'En colaboración con Dahlgren Duck'
  },
  reqConsultNav: {
    en: 'Request a Private Consultation',
    es: 'Solicitar consulta privada'
  },
  // Hero
  heroHeadline: {
    en: 'Luxury Without Complexity.',
    es: 'Lujo sin complejidad.'
  },
  heroSub: {
    en: 'I help aviation, yachting, residential, and hospitality teams curate, source, and deliver world-class OS&E, FF&E, and bespoke solutions—without the stress of managing dozens of vendors.',
    es: 'Ayudo a equipos de aviación, yachting, residencial y hospitalidad a curar, gestionar y entregar OS&E, FF&E y soluciones bespoke de nivel mundial—sin el estrés de coordinar decenas de proveedores.'
  },
  heroTrust: {
    en: 'Discreet guidance. Global execution. One point of contact.',
    es: 'Discreción. Precisión. Un solo punto de contacto.'
  },
  btnPrimary: {
    en: 'Request a Private Consultation',
    es: 'Solicitar consulta privada'
  },
  btnSecondary: {
    en: 'View How It Works',
    es: 'Ver cómo funciona'
  },
  chip1: {
    en: 'Global sourcing',
    es: 'Sourcing global'
  },
  chip2: {
    en: 'White-glove logistics',
    es: 'Logística white-glove'
  },
  chip3: {
    en: 'Bespoke options',
    es: 'Opciones bespoke'
  },
  chip4: {
    en: 'Discrete coordination',
    es: 'Coordinación discreta'
  },
  heroCaption: {
    en: 'Private client advisory • Global procurement coordination',
    es: 'Asesoría privada • Coordinación global de compras'
  },
  // Authority
  authTitle: {
    en: 'Your single point of contact in a high-stakes world.',
    es: 'Un solo punto de contacto en un mundo de alta exigencia.'
  },
  authBody: {
    en: "When timelines are tight and expectations are uncompromising, you don't need more vendors—you need one trusted advisor who can orchestrate everything with calm precision.",
    es: 'Cuando los tiempos son ajustados y las expectativas no admiten errores, no necesitas más proveedores—necesitas una asesora confiable que orqueste todo con precisión y calma.'
  },
  authBul1: {
    en: 'One advisor for complex global projects',
    es: 'Una asesora para proyectos globales complejos'
  },
  authBul2: {
    en: 'Curated access to heritage brands and bespoke ateliers',
    es: 'Acceso curado a casas icónicas y ateliers bespoke'
  },
  authBul3: {
    en: 'Logistics simplified through consolidation and coordination',
    es: 'Logística simplificada con consolidación y coordinación'
  },
  authBul4: {
    en: 'Detail-led execution designed to protect your reputation',
    es: 'Ejecución detallista para proteger tu reputación'
  },
  authMicro: {
    en: "Supported by Dahlgren Duck's global luxury outfitting infrastructure.",
    es: 'Respaldado por la infraestructura global de Dahlgren Duck.'
  },
  // Before / After
  baBefore: {
    en: 'Before',
    es: 'Antes'
  },
  baAfter: {
    en: 'After',
    es: 'Después'
  },
  b1: {
    en: 'Too many suppliers, too little control',
    es: 'Demasiados proveedores, poco control'
  },
  b2: {
    en: 'Delays that create reputation risk',
    es: 'Retrasos que generan riesgo reputacional'
  },
  b3: {
    en: 'Decision fatigue across thousands of SKUs',
    es: 'Fatiga de decisión entre miles de SKUs'
  },
  b4: {
    en: 'Inconsistent quality across regions',
    es: 'Calidad inconsistente entre regiones'
  },
  a1: {
    en: 'One trusted advisor, end-to-end',
    es: 'Una asesora de confianza, de principio a fin'
  },
  a2: {
    en: 'Calm execution with clear milestones',
    es: 'Ejecución serena con hitos claros'
  },
  a3: {
    en: 'Curated selections aligned with your vision',
    es: 'Selecciones curadas alineadas a tu visión'
  },
  a4: {
    en: 'Seamless delivery through coordinated logistics',
    es: 'Entrega impecable mediante logística coordinada'
  },
  // How It Works
  hwTitle: {
    en: 'How It Works',
    es: 'Cómo funciona'
  },
  hw1Title: {
    en: 'Vision Alignment',
    es: 'Alineación de visión'
  },
  hw1Desc: {
    en: 'We define the aesthetic, standards, timelines, and constraints.',
    es: 'Definimos estética, estándares, tiempos y límites.'
  },
  hw2Title: {
    en: 'Strategic Curation',
    es: 'Curaduría estratégica'
  },
  hw2Desc: {
    en: 'I curate options that match the space, lifestyle, and expectations.',
    es: 'Selecciono opciones alineadas con el espacio y el estilo de vida.'
  },
  hw3Title: {
    en: 'Consolidation & Logistics',
    es: 'Consolidación y logística'
  },
  hw3Desc: {
    en: 'Coordination, consolidation, and delivery planning—globally.',
    es: 'Coordinación, consolidación y planeación de entrega global.'
  },
  hw4Title: {
    en: 'White-Glove Support',
    es: 'Soporte white-glove'
  },
  hw4Desc: {
    en: 'Support through final delivery details and adjustments.',
    es: 'Acompañamiento hasta el cierre y ajustes finales.'
  },
  // Industries
  indTitle: {
    en: 'Industries Served',
    es: 'Industrias atendidas'
  },
  ind1Title: {
    en: 'Private Travel',
    es: 'Aviación Privada'
  },
  ind1Desc: {
    en: 'Cabin-ready luxury and flawless readiness—without procurement chaos.',
    es: 'Lujo listo para cabina y preparación impecable—sin caos de compras.'
  },
  ind2Title: {
    en: 'Superyachts',
    es: 'Superyates'
  },
  ind2Desc: {
    en: 'Discretion, durability, and refined details built for life at sea.',
    es: 'Discreción, durabilidad y detalles refinados creados para la vida en el mar.'
  },
  ind3Title: {
    en: 'Luxury Residential',
    es: 'Residencial de Lujo'
  },
  ind3Desc: {
    en: 'A home that feels inevitable—quiet, complete, and personal.',
    es: 'Un hogar que se siente inevitable—sereno, completo y personal.'
  },
  ind4Title: {
    en: 'Hospitality',
    es: 'Hospitalidad'
  },
  ind4Desc: {
    en: 'Guest experiences elevated through consistent standards and sourcing.',
    es: 'Experiencias de huéspedes elevadas mediante estándares y sourcing consistentes.'
  },
  // Trust
  trustTitle: {
    en: 'Trusted relationships. Global reach.',
    es: 'Relaciones de confianza. Alcance global.'
  },
  trustBody: {
    en: 'Work is executed with discretion and aligned to the standards of elite environments.',
    es: 'El trabajo se ejecuta con discreción y alineado a los estándares de entornos de élite.'
  },
  trustFooter: {
    en: 'Global presence: Dallas • Denver • Dubai • London',
    es: 'Presencia global: Dallas • Denver • Dubái • Londres'
  },
  // Form
  formTitle: {
    en: 'Request a Private Consultation',
    es: 'Solicitar consulta privada'
  },
  formSub: {
    en: "Share a few details. I'll respond personally.",
    es: 'Comparte algunos detalles. Te responderé personalmente.'
  },
  fName: {
    en: 'Full Name',
    es: 'Nombre completo'
  },
  fEmail: {
    en: 'Email Address',
    es: 'Correo electrónico'
  },
  fPhone: {
    en: 'Phone (Optional)',
    es: 'Teléfono (Opcional)'
  },
  fCompany: {
    en: 'Company / Role',
    es: 'Empresa / Cargo'
  },
  fIndustry: {
    en: 'Industry',
    es: 'Industria'
  },
  fIndOpt1: {
    en: 'Private Travel',
    es: 'Aviación Privada'
  },
  fIndOpt2: {
    en: 'Superyachts',
    es: 'Superyates'
  },
  fIndOpt3: {
    en: 'Residential',
    es: 'Residencial'
  },
  fIndOpt4: {
    en: 'Hospitality',
    es: 'Hospitalidad'
  },
  fIndOpt5: {
    en: 'Other',
    es: 'Otro'
  },
  fLocation: {
    en: 'Project Location',
    es: 'Ubicación del proyecto'
  },
  fTimeline: {
    en: 'Timeline',
    es: 'Tiempos'
  },
  fTimeOpt1: {
    en: 'ASAP',
    es: 'Lo antes posible'
  },
  fTimeOpt2: {
    en: '1–3 months',
    es: '1–3 meses'
  },
  fTimeOpt3: {
    en: '3–6 months',
    es: '3–6 meses'
  },
  fTimeOpt4: {
    en: '6+ months',
    es: 'Más de 6 meses'
  },
  fBudget: {
    en: 'Budget Range (Optional)',
    es: 'Rango de presupuesto (Opcional)'
  },
  fBudOpt1: {
    en: 'Prefer not to say',
    es: 'Prefiero no decirlo'
  },
  fMessage: {
    en: 'Message',
    es: 'Mensaje'
  },
  formSubmit: {
    en: 'Submit Private Inquiry',
    es: 'Enviar solicitud privada'
  },
  formMicro: {
    en: 'Discretion is respected. Your information is never shared.',
    es: 'La discreción es prioridad. Tu información nunca se comparte.'
  },
  formSuccess: {
    en: 'Inquiry received. Emelyn De Martino will follow up shortly.',
    es: 'Solicitud recibida. Emelyn De Martino te contactará pronto.'
  },
  // Footer
  terms: {
    en: 'Terms',
    es: 'Términos'
  },
  privacy: {
    en: 'Privacy',
    es: 'Privacidad'
  },
  // Anti-copy Toast
  protected: {
    en: 'Content is protected.',
    es: 'El contenido está protegido.'
  }
};
interface I18nContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: string) => string;
}
const I18nContext = createContext<I18nContextType | undefined>(undefined);
export const I18nProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [lang, setLangState] = useState<Language>('en');
  useEffect(() => {
    const saved = localStorage.getItem('emelyn_lang') as Language;
    if (saved && (saved === 'en' || saved === 'es')) {
      setLangState(saved);
    }
  }, []);
  const setLang = (newLang: Language) => {
    setLangState(newLang);
    localStorage.setItem('emelyn_lang', newLang);
  };
  const t = (key: string): string => {
    if (!translations[key]) {
      console.warn(`Translation key not found: ${key}`);
      return key;
    }
    return translations[key][lang];
  };
  return <I18nContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-198">
      {children}
    </I18nContext.Provider>;
};
export const useI18n = () => {
  const context = useContext(I18nContext);
  if (!context) throw new Error('useI18n must be used within I18nProvider');
  return context;
};